import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GeneralModal from '@app/components/modals/GeneralModal';

export interface ContinueWithoutDocumentsModalProps {
  onDone: (shouldContinue: boolean) => void;
}

/**
 * Content launched via showCustomModalAsync (see SupplierRegistrationCompanyInformation's
 * showContinueWithoutDocumentsModal) when the supplier tries to move on with a document section
 * still empty -- mirrors IsraelConfirmationModal's shape (a content component driven by an
 * imperative modal launcher, not a controlled `open` prop) since this, unlike
 * EmailVerificationModal, has no session state of its own to restore on mount.
 */
const ContinueWithoutDocumentsModal: FC<ContinueWithoutDocumentsModalProps> = (props) => {
  const { onDone } = props;
  const { t } = useTranslation();

  return (
    <GeneralModal
      title={t('supplierValidation.supplierRegister.documents.skipModal.title')}
      okText={t('supplierValidation.supplierRegister.documents.skipModal.continue')}
      onOk={(): void => onDone(true)}
      cancelText={t('supplierValidation.supplierRegister.documents.skipModal.goBack')}
      onCancel={(): void => onDone(false)}
    >
      {t('supplierValidation.supplierRegister.documents.skipModal.body')}
    </GeneralModal>
  );
};

export default ContinueWithoutDocumentsModal;
